import React from 'react';
import { Github, Linkedin, Mail, Heart } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = ({ personal }) => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  return (
    <footer className="bg-gradient-to-b from-background to-muted dark:from-background dark:to-muted border-t border-border/50">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 py-12">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          {/* Left side - Branding */}
          <div>
            <h3 className="text-2xl font-semibold text-foreground mb-3">
              Tymur Abkiliamov
            </h3>
            <p className="text-muted-foreground mb-6 leading-relaxed">
              {t('footer.description')}
            </p>
            <div className="flex space-x-3">
              <a
                href="https://github.com/tabkiliamov"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 rounded-lg border border-border/50 text-muted-foreground hover:bg-blue-600 hover:text-white hover:border-blue-600 hover:shadow-md hover:shadow-blue-600/20 transition-all duration-300"
                aria-label="GitHub"
              >
                <Github className="h-5 w-5" />
              </a>
              <a
                href="https://www.linkedin.com/in/tymur-abkiliamov-0324a637a/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 rounded-lg border border-border/50 text-muted-foreground hover:bg-blue-600 hover:text-white hover:border-blue-600 hover:shadow-md hover:shadow-blue-600/20 transition-all duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
              <a
                href={`mailto:${personal.email}`}
                className="p-2.5 rounded-lg border border-border/50 text-muted-foreground hover:bg-blue-600 hover:text-white hover:border-blue-600 hover:shadow-md hover:shadow-blue-600/20 transition-all duration-300"
                aria-label="Email"
                title={personal.email}
              >
                <Mail className="h-5 w-5" />
              </a>
              {personal.emailSecondary && (
                <a
                  href={`mailto:${personal.emailSecondary}`}
                  className="p-2.5 rounded-lg border border-border/50 text-muted-foreground hover:bg-blue-600 hover:text-white hover:border-blue-600 hover:shadow-md hover:shadow-blue-600/20 transition-all duration-300"
                  aria-label="Secondary Email"
                  title={personal.emailSecondary}
                >
                  <Mail className="h-5 w-5" />
                </a>
              )}
            </div>
          </div>

          {/* Right side - Quick links */}
          <div className="md:text-right">
            <h4 className="text-lg font-medium text-foreground mb-4">{t('footer.quickLinks')}</h4>
            <div className="space-y-2">
              {[
                { href: '#about', label: t('navigation.about') },
                { href: '#projects', label: t('projects.title') },
                { href: '#experience', label: t('navigation.experience') },
                { href: '#contact', label: t('navigation.contact') },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="block text-muted-foreground hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom section */}
        <div className="mt-12 pt-8 border-t border-border/50 text-center">
          <p className="text-muted-foreground text-sm flex items-center justify-center">
            &copy; {currentYear} Tymur Abkiliamov. {t('footer.builtWith')}
            <Heart className="h-4 w-4 text-red-500 mx-1" fill="currentColor" />
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
